/* Confort — actualiza la barra de envío gratis sin recargar.
   El total sale siempre de /cart.js, que es lo que cobra el checkout. */
(function () {
  'use strict';

  function pesos(centavos) {
    return '$' + (centavos / 100).toLocaleString('es-AR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function pintar(total) {
    document.querySelectorAll('[data-cc-envio]').forEach(function (el) {
      var umbral = parseInt(el.getAttribute('data-umbral'), 10);
      if (!umbral) return;

      var falta = umbral - total;
      var pct = Math.max(0, Math.min(100, Math.round((total * 100) / umbral)));

      var texto = el.querySelector('[data-cc-envio-text]');
      if (texto) {
        texto.innerHTML = falta > 0
          ? 'Te faltan <strong>' + pesos(falta) + '</strong> para el envío gratis'
          : '<strong>¡Tenés envío gratis!</strong>';
      }

      var relleno = el.querySelector('[data-cc-envio-fill]');
      if (relleno) relleno.style.width = pct + '%';

      var barra = el.querySelector('[data-cc-envio-bar]');
      if (barra) barra.setAttribute('aria-valuenow', String(pct));

      el.classList.toggle('is-listo', falta <= 0);
    });
  }

  function refrescar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { pintar(cart.total_price); })
      .catch(function () { /* queda el valor que pintó el servidor */ });
  }

  // La barra es fija, así que sale del flujo. Medimos su alto real y lo
  // publicamos en --cc-envio-h para que .page-wrapper lo compense.
  // Se recalcula al cambiar el ancho, porque en mobile pasa a dos renglones.
  function medir() {
    var barra = document.querySelector('[data-cc-envio]');
    if (barra) {
      document.documentElement.style.setProperty('--cc-envio-h', barra.offsetHeight + 'px');
    }
    // Alto del encabezado: la barra se pega justo debajo. Lo medimos acá en
    // vez de usar la variable del tema, que en algunos estados vale 0.
    var header = document.querySelector('.header-section') ||
                 document.querySelector('#header-component');
    if (header && header.offsetHeight) {
      document.documentElement.style.setProperty('--cc-header-h', header.offsetHeight + 'px');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', medir);
  } else {
    medir();
  }
  var medirTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(medirTimer);
    medirTimer = setTimeout(medir, 150);
  });
  window.addEventListener('load', medir);

  // ---- Barra de anuncios: cinta continua ----
  // Envuelve el anuncio en .cc-cinta y la repite hasta cubrir la pantalla.
  // Envolver evita depender de cuántos elementos meta el tema adentro.
  var MARQUEE_PX_POR_SEGUNDO = 45; // velocidad real, no depende del largo

  function armarMarquee() {
    var slides = document.querySelector('.announcement-bar__slides');
    if (!slides) return;

    var hijos = Array.prototype.slice.call(slides.children);
    var cinta = null;
    hijos.forEach(function (el) {
      if (el.classList.contains('cc-copia')) el.remove();
      else if (el.classList.contains('cc-cinta')) cinta = el;
    });

    if (!cinta) {
      // más de un anuncio: manda el pasaje de diapositivas del tema
      if (slides.children.length !== 1) return;
      cinta = document.createElement('div');
      cinta.className = 'cc-cinta';
      while (slides.firstChild) cinta.appendChild(slides.firstChild);
      slides.appendChild(cinta);
    }

    var ancho = cinta.offsetWidth;
    if (!ancho) return;

    var porGrupo = Math.max(1, Math.ceil((window.innerWidth || ancho) / ancho));
    for (var i = 1; i < porGrupo * 2; i++) {
      var copia = cinta.cloneNode(true);
      copia.classList.add('cc-copia');
      copia.setAttribute('aria-hidden', 'true');
      slides.appendChild(copia);
    }

    slides.style.animationDuration =
      ((ancho * porGrupo) / MARQUEE_PX_POR_SEGUNDO).toFixed(2) + 's';
  }

  var marqueeTimer = null;
  function armarMarqueeDiferido() {
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(armarMarquee, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armarMarquee);
  } else {
    armarMarquee();
  }
  window.addEventListener('load', armarMarquee);
  window.addEventListener('resize', armarMarqueeDiferido);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(armarMarquee); // el ancho cambia al cargar la tipografía
  }

  // ---- Etiqueta del botón de pago acelerado ----
  // El texto lo genera Shopify, no el tema, así que se reescribe acá.
  // Solo toca el botón sin marca y solo si dice "comprar ahora": si es
  // un botón de billetera tipo Shop Pay, se deja como está.
  function renombrarComprar() {
    document.querySelectorAll('.shopify-payment-button__button').forEach(function (btn) {
      if (btn.dataset.ccTexto === '1') return;
      var t = (btn.textContent || '').trim();
      if (!/^comprar ahora$/i.test(t)) return;
      btn.dataset.ccTexto = '1';
      btn.textContent = 'Comprar';
    });
  }

  // El botón lo dibuja Shopify después de cargar la página, así que hay
  // que esperarlo en vez de buscarlo una sola vez.
  function vigilarComprar() {
    renombrarComprar();
    var caja = document.querySelector('.shopify-payment-button');
    if (!caja || !window.MutationObserver) return;
    new MutationObserver(renombrarComprar).observe(caja, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilarComprar);
  } else {
    vigilarComprar();
  }
  window.addEventListener('load', renombrarComprar);

  // Evento propio de Horizon al agregar, quitar o cambiar cantidades
  // Al tocar varias veces el + llegan varios avisos seguidos. Sin esto se
  // dispara una lectura del carrito por cada uno y la barra se traba.
  var refrescoTimer = null;
  function refrescarPronto() {
    clearTimeout(refrescoTimer);
    refrescoTimer = setTimeout(refrescar, 250);
  }

  document.addEventListener('shopify:cart:lines-update', refrescarPronto);
  // Al editar secciones en el personalizador
  document.addEventListener('shopify:section:load', refrescar);
  // Al volver con el botón atrás, donde el navegador sirve una copia cacheada
  window.addEventListener('pageshow', function (e) { if (e.persisted) refrescar(); });
})();